<template>
  <div class="auth-login">
    <section class="auth-login__img" />
    <section class="auth-login__content position-relative">
      <div class="auth-login__block">
        <div class="auth-login__logo">
          <img src="@/assets/images/logo.svg" alt="logo" />
        </div>
        <el-form :model="form" :rules="rules" ref="form" class="auth-card">
          <h1 class="auth-login__title mt-0 mb-4">Авторизация</h1>
          <div v-if="showError" class="auth-login__error">Указан неверный email или пароль</div>
          <el-form-item prop="login" class="auth-login__item" :class="{'is-error': showError}">
            <el-input v-model="form.login" />
            <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(form.login) }">Email</span>
          </el-form-item>
          <el-form-item prop="password" class="auth-login__item" :class="{'is-error': showError}">
            <el-input v-model="form.password" show-password />
            <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(form.password) }">Пароль</span>
          </el-form-item>
          <div class="auth-login__actions">
            <el-button type="primary" @click="onSubmit" class="w-100" :disabled="loading"> Войти </el-button>
          </div>
        </el-form>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { MESSAGES } from '@/commons/constants/errorMessages';

export default {
  data: () => ({
    showError: false,
    form: {
      login: '',
      password: '',
    },
    rules: {
      login: [
        { required: true, message: MESSAGES.REQUIRED, trigger: 'change' },
        { type: 'email', message: MESSAGES.INCORRECT_EMAIL, trigger: 'blur' },
      ],
      password: [{ required: true, message: MESSAGES.REQUIRED, trigger: 'change' }],
    },
  }),

  computed: {
    ...mapGetters({
      loading: 'auth/loading',
    }),
  },

  methods: {
    ...mapActions({
      login: 'auth/login',
    }),
    onSubmit() {
      this.showError = false;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.login(this.form)
            .then(() => {
              this.$router.push({ name: 'Workouts' });
            }).catch(() => {
            // this.showError = true;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
